import { makeStyles } from '@fluentui/react-components';
export var useAnnouncerStyles = makeStyles({
    container: {
        top: '-9999px',
        left: '-9999px',
        position: 'absolute',
    },
});
//# sourceMappingURL=Announcer.styles.js.map